import { date as mixDate } from "@/components/mixins/date";

export const getPagination = ({ skip, limit }) => {
  return {
    skip: skip || 0,
    limit: limit || 0
  };
};

export const getDataChannel = type => {
  switch (type) {
    case "productions":
      return "Logs/ProdLog";
    case "events":
      return "Logs/EventLog";
    case "alarms":
      return "Logs/AlarmLog";
    default:
      return "";
  }
};

export const itemsToTableItems = params => {
  const { items, locale, t, formatDate = true, dateTimeAtBeginning = false } = params;

  let DateFrom = undefined;
  let DateTo = undefined;

  return (items || []).map(obj => {
    if (obj.DateFrom && formatDate) {
      DateFrom = mixDate.methods.formatDateMedFull(obj.DateFrom, locale);
      if (dateTimeAtBeginning) {
        delete obj.DateFrom;
      } else {
        obj.DateFrom = DateFrom;
      }
    }
    if (obj.DateTo && formatDate) {
      DateTo = mixDate.methods.formatDateMedFull(obj.DateTo, locale);
      if (dateTimeAtBeginning) {
        delete obj.DateTo;
      } else {
        obj.DateTo = DateTo;
      }
    }
    if (obj.at) {
      delete obj.at;
    }
    if (obj["IsWaste"] !== undefined) {
      obj.IsWaste = obj.IsWaste === 0 ? t("misc.no") : t("misc.yes");
    }
    if (obj.Version) {
      delete obj.Version;
    }

    const newObj = dateTimeAtBeginning
      ? {
          DateFrom,
          DateTo,
          ...obj
        }
      : { ...obj };

    // 26/2/2021: Delete properties are type OBJECT or ARRAY, only string o number
    // Es. "Infomix" per le SEZIONATRICI
    for (const key in newObj) {
      if (typeof newObj[key] !== "string" && typeof newObj[key] !== "number") {
        delete newObj[key];
      }
    }
    // ---
    return newObj;
  });
};

const filterDate = params => {
  const { date, hour, minute, second, millisecond } = params;
  const newDate = date && mixDate.methods.getCustomFormatDate(date, "yyyy-MM-dd");
  return mixDate.methods.dateFromObj(newDate, { hour, minute, second, millisecond });
};

export const filterFrom = date => {
  return filterDate({
    date,
    hour: 7,
    minute: 0,
    second: 0,
    millisecond: 0
  });
};

export const filterTo = date => {
  return filterDate({
    date,
    hour: 23,
    minute: 59,
    second: 59,
    millisecond: 0
  });
};

export const logFilter = params => {
  let result;

  if (params) {
    const from = filterFrom(params.from);
    const to = filterTo(params.to);

    return {
      ...params,
      from,
      to
    };
  }

  return result;
};
